import {MeshTable} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/mesh/MeshTable';
import {FramePath} from '@mintdata/mint-kit/api/values/frames/Frame';
import {IStyles, Styles} from '@mintdata/mint-kit/impl/util/Styles';
import * as classnames from 'classnames/bind';
import {observer, inject} from 'mobx-react';
import * as React from 'react';
import {IWSPMeshContext} from '@mintdata-wsp/wsp/controllers/visualDesigner/spreadsheet/contexts/MeshContext';

const meshViewStyles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/mesh/Mesh.less');
const cx = classnames.bind(meshViewStyles);

interface IMeshViewProps
{
    ctx?:IWSPMeshContext;
    isNested?:boolean;
    theme?:IStyles;
    isScrollEnabled?:boolean;
    pathInFrame?:FramePath;
}

@inject('ctx')
@observer
export class MeshView extends React.Component<IMeshViewProps, any>
{
    public componentWillMount():void
    {
        const {theme} = this.props;
        this._initStyles(theme);
    }

    public componentWillReceiveProps(newProps:IMeshViewProps):void
    {
        const {theme} = this.props;

        if( theme !== newProps.theme )
            this._initStyles(newProps.theme);
    }

    private _initStyles(theme:IStyles):void
    {
        this.setState(
            {
                styles: Styles.mergeStyles(meshViewStyles, theme || {}),
            });
    }

    public render():JSX.Element
    {
        const {isNested} = this.props;

        return (
            <div className={cx('meshView', {nested: isNested})}>
                <MeshTable {...this.props} />
            </div>
        );
    }
}
